<template>
    <b-container class="techTechnologies">
        <b-row>
            <b-col cols="12">
                <h2 class="bold center">{{technologies.title}}</h2>
            </b-col>
            <b-col cols="12" v-for="(x, i) in technologies.technologies" :key="i" class="techContent">
                <p class="techField bold pink">{{x.title}}</p>
                <div class="technologies">
                    <div class="technology" v-for="(y, i) in x.tech" :key="i">
                        <img class="technologyImg" :src="getImg(y.img)" alt="technology logo">
                        <p>{{y.name}}</p>
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import json from '@/locales/en.json'

export default {
    name:"techTechnologies",
    data: function() {
        return {
            technologies: json.pageTech.tech
        }
    },
    methods: {
        getImg: function(img) {
            return require('../../assets/imagesTech/'+img)
        }
    }
}
</script>

<style lang="scss" scoped>
.technologies{
    display:flex;
    align-items: center;
    flex-wrap: wrap;
}

.technology {
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.1);
    background-color: white;
    border-radius:15px;
    height:170px;
    width:170px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    margin:10px;
    text-align: center;
}

.technology p {
    margin-bottom:0px;
}

.technologyImg {
    max-width: 80%;
}

.techContent{
    margin-top:60px;
}

.techField{
    height:25px;
    font-size: 20px;
    padding:20px 0;
    font-family: $font;
    border-top: 1px solid $pink;
}

@media (max-width:991px) {
    .technology{
        width:90px;
        height:90px;
        font-size:13px;
    }

    img {
        width:50%;
    }

    p {
        margin-block-end: 0;
    }

}

@media (max-width:768px) {
    .techField{
        height:60px;
    }
    
}
</style>